/**
 * TwToast Service
 *
 * Plain JS singleton — no Vue dependency.
 * Holds a queue for notifications that arrive before the TwToastContainer mounts,
 * then flushes them once the container is ready.
 *
 * window.$notify is set synchronously at module parse time so Twig inline
 * <script> tags (which fire after the bundle loads but before Vue mounts)
 * are captured correctly.
 */

const toastService = {
  _vm: null,
  _queue: [],

  /**
   * Add a notification. Queues it if the container isn't mounted yet.
   * @param {Object|string} opts - { title?, message, type?, duration? } or plain string
   * @param {string} [type] - shorthand type when opts is a string
   */
  add(opts, type) {
    const normalized = typeof opts === 'string' ? { message: opts, type: type || 'info' } : opts;

    if (this._vm) {
      this._vm.addToast(normalized);
    } else {
      this._queue.push(normalized);
    }
  },

  /**
   * Called by TwToastContainer.mounted(). Drains all queued notifications:
   * - toastService._queue: calls that arrived after this module loaded
   * - window.__notifyQueue: calls that arrived before this module loaded
   *   (from the synchronous stub at the top of app.js)
   * @param {Vue} vm - the TwToastContainer instance
   */
  flush(vm) {
    this._vm = vm;

    // Drain pre-mount stub queue (Twig flash scripts, other inline JS)
    if (typeof window !== 'undefined' && Array.isArray(window.__notifyQueue)) {
      window.__notifyQueue.forEach((o) => vm.addToast(o));
      window.__notifyQueue = [];
    }

    // Drain internal queue
    this._queue.forEach((o) => vm.addToast(o));
    this._queue = [];
  },
};

// Replace the stub set by app.js with the real implementation now that
// this module has loaded. Any calls from here forward go directly to the
// service rather than the pre-mount queue.
if (typeof window !== 'undefined') {
  window.$notify = (opts, type) => toastService.add(opts, type);
}

export default toastService;
